import language from '#scripts/translation';
import { findCategoryPaths } from '#scripts/nav';

export default function (value) {
  const backto = () => {
    return language('NAV_FRONTPAGE');
  };

  let storedBreadcrumbs = "";
  if (sessionStorage.getItem("breadcrumbs") !== null && sessionStorage.getItem("breadcrumbs") !== "") {
    storedBreadcrumbs = sessionStorage.getItem("breadcrumbs")
  } else {
    const allCats = JSON.parse(sessionStorage.getItem("aim-categories"));
    const categoriesToFind = articleParsed.categories ? articleParsed.categories.map(cat => cat.categoryId) : [];
    const allCategoryPaths = categoriesToFind.map(categoryId => findCategoryPaths(allCats, [categoryId]));

    let foundBreadcrumb = "";
    if (allCategoryPaths.length === 1) {
      // Only one category set, so use this
      // Sometimes we get a category that is null, so check for that
      if (allCategoryPaths[0] === null) {
        return "";
      }

      const { path, urlPath } = allCategoryPaths[0];
      let htmlString = "";

      path.forEach((part, index) => {
        if (urlPath[index].startsWith("/")) {
          htmlString += `<li class="aim-breadcrumb-item"><a href='${urlPath[index]}'>${part}</a></li>`;
        } else {
          htmlString += `<li class="aim-breadcrumb-item"><a href='/nav/${urlPath[index]}'>${part}</a></li>`;
        }
      });
      foundBreadcrumb = htmlString;
    }

    // Check if one of the path has a match to refferer (a nav page)
    allCategoryPaths.forEach(categoryPath => {
      if (categoryPath !== null) {
        const { path, urlPath } = categoryPath;
        if (document.referrer.includes(categoryPath.urlPath[categoryPath.urlPath.length - 1])) {
          let htmlString = "";

          path.forEach((part, index) => {
            if (urlPath[index].startsWith("/")) {
              htmlString += `<li class="aim-breadcrumb-item"><a href='${urlPath[index]}'>${part}</a></li>`;
            } else {
              htmlString += `<li class="aim-breadcrumb-item"><a href='/nav/${urlPath[index]}'>${part}</a></li>`;
            }
          });
          foundBreadcrumb = htmlString;
        }
      }
    });

    // If still no match, choose one (for now take the first)
    if (foundBreadcrumb === "" && allCategoryPaths.length > 1) {
      if (allCategoryPaths[0] !== null) {
        const { path, urlPath } = allCategoryPaths[0];
        let htmlString = "";

        path.forEach((part, index) => {
          if (urlPath[index].startsWith("/")) {
            htmlString += `<li class="aim-breadcrumb-item"><a href='${urlPath[index]}'>${part}</a></li>`;
          } else {
            htmlString += `<li class="aim-breadcrumb-item"><a href='/nav/${urlPath[index]}'>${part}</a></li>`;
          }
        });
        foundBreadcrumb = htmlString;
      }
    }

    storedBreadcrumbs = `
                      <li class="aim-breadcrumb-item"><a href="/">${backto()}</a></li>
                      <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb"></li>
                      `;

    const shortNewsBreadcrumb = window.serverdata.configMeta.aim?.showShortNewsBreadcrumb ?? true;
    const isNewsArticle = articleParsed.pageTypeId === "mal_nyhet";
    const useShortNewsBreadcrumb = isNewsArticle && shortNewsBreadcrumb;
    if (!useShortNewsBreadcrumb) {
      storedBreadcrumbs = `
                      <li class="aim-breadcrumb-item"><a href="/">${backto()}</a></li>
                      ${foundBreadcrumb}
                      <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb"></li>`;
    }
  }
  return `
    <div class="row">
        <div class="col-sm-12">
            <div class="fullnav__breadcrumb__container">
                <nav aria-label="breadcrumb">
                    <ol class="aim-breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
                        ${storedBreadcrumbs}
                    </ol>
                </nav>
            </div>
        </div>
    </div>`;
}

